import { createFileRoute } from '@tanstack/react-router'
import { KOTServerInterface } from '@/components/server/KOTServerInterface'

function ServerRoutePage() {
  return (
    <div className="flex h-full min-h-0 flex-col overflow-hidden bg-background">
      <KOTServerInterface />
    </div>
  )
}

export const Route = createFileRoute('/admin/server')({
  component: ServerRoutePage,
})
